
import React from 'react';

export interface VoxelButtonGroupProps {
  gapClass?: string;
}

const VoxelButtonGroup: React.FC<VoxelButtonGroupProps> = ({
  gapClass,
  children
}) => {
  return (
    <div className={`flex flex-row flex-nowrap items-center rounded-full ${gapClass}`}>
      {children}
    </div>
  );
};

export default VoxelButtonGroup;
